__turbopack_context__.v({
  "menu": "hbXbHG_menu",
  "trigger": "hbXbHG_trigger",
  "trigger--selected": "hbXbHG_trigger--selected",
});
